import React, { FC } from "react";
import Link from "next/link";
import type { ProductPreviewImage } from "ui/ProductPreviewImage/ProductPreviewImage";
import { LinkProps } from "helpers/url";
import { cn } from "helpers/style";

import styles from "./ImagePlaceholder.module.scss";

type Props = Partial<{
  type: ProductPreviewImage;
  linkProps: LinkProps;
  onClick: () => void;
  onMouseDown: (e: React.MouseEvent) => void;
  className: string;
}>;

const ImagePlaceholder: FC<Props> = ({
  type = "regular",
  linkProps,
  onClick,
  onMouseDown,
  className = null,
}) => {
  return (
    <Link {...linkProps} legacyBehavior passHref>
      <a
        type={type}
        className={cn([
          styles.wrapper,
          type === "horizontal" && styles.wrapperHorizontal,
          type === "horizontalSmall" && styles.wrapperHorizontalSmall,
          type === "regular" && styles.wrapperRegular,
          className,
        ])}
        onClick={() => onClick && onClick()}
        onMouseDown={onMouseDown}
      >
        <img
          src="/img/product/image-placeholder.svg"
          alt="Изображение отсутствует"
        />
        {["regular", "horizontal"].includes(type) && (
          <p>Изображение отсутствует</p>
        )}
      </a>
    </Link>
  );
};

export default ImagePlaceholder;
